import React, { useState, useEffect } from "react";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Experience from "./components/Experience/Experience";
import Loading from "./components/Loading/Loading";
import Stats from "./components/Stats/Stats";
import Skills from "./components/Skills/Skills";
import Achievement from "./components/Achievement/Achievement";
import Projects from "./components/Projects/Projects";
import Contact from "./components/Contact/Contact";
import About from "./components/About/About";
import Hero from "./components/Hero/Hero";
import Parallax from "./components/Parallax/Parallax";
import cursorEffect from "./utils/cursorEffect";

function App() {
  const [isHeaderActive, setIsHeaderActive] = useState(false);
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") || "dark_theme"
  );

  useEffect(() => {
    const handleScroll = () => {
      setIsHeaderActive(window.scrollY >= 10);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    document.body.className = theme;
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === "light_theme" ? "dark_theme" : "light_theme");
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // cursor move effect
  useEffect(() => {
    cursorEffect();
  }, []);

  return (
    <div className="App">
      <div id="top" className={theme}>
        {/* <Loading /> */}
        <Header isLightTheme={theme === "light_theme"} />

        <main>
          <article className="container">
            <Hero toggleTheme={toggleTheme} />
            <Stats />
            {/* </article>

          <Parallax isLightTheme={theme === "light_theme"} />

          <article className="container"> */}
            <About theme={theme}/>
            <Experience />
            <Skills />
            <Achievement />
            <Projects />
            <Contact theme={theme} />
          </article>
        </main>

        <Footer />

        <button
          onClick={scrollToTop}
          className={`go-top ${isHeaderActive ? "active" : ""}`}
          data-go-top
          title="Go to Top"
        >
          <ion-icon name="arrow-up"></ion-icon>
        </button>
      </div>
    </div>
  );
}

export default App;
